import { Controller } from "@hotwired/stimulus"

// サイドバーのセクション ( ヘッダー + コンテンツ ) を展開 / 折りたたみする。
// open-value=true のときコンテンツを表示。 chevron は 90 度回転で開閉状態を示す。
export default class extends Controller {
  static targets = ["content", "chevron"]
  static values = { open: Boolean }

  connect() {
    this.update()
  }

  toggle(event) {
    event?.preventDefault()
    this.openValue = !this.openValue
    this.update()
  }

  update() {
    if (this.hasContentTarget) {
      this.contentTarget.classList.toggle("hidden", !this.openValue)
    }
    if (this.hasChevronTarget) {
      this.chevronTarget.classList.toggle("rotate-90", this.openValue)
    }
  }
}
